import { BASEURL } from "../BaseUrl";

/**
 * Fetches dashboard data for the specified user.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {Object} data - The parameters for the request.
 * @param {string} data.user_id - The ID of the user whose dashboard data is to be fetched.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getAllDashboardData = async (axios, data) => {
  return await axios.get(`${BASEURL}/dashboard/get-dashboard-count`, {
    params: {
      user_id: data.user_id,
    },
  });
};

export const DashboardApi = {
  getAllDashboardData,
};
